<template>
    <LegalDocument :title="TITLE" :html="vopB2bHtml" />
</template>

<script setup lang="ts">
import vopB2bHtml from '@/assets/legal/vop-b2b.html?raw'
import LegalDocument from '@/components/legal/LegalDocument.vue'

const TITLE = 'Všeobecné obchodné podmienky pre obchodných partnerov (VOP B2B)'

useHead({
    title: `${TITLE} | GROWNi`,
    meta: [
        {
            name: 'description',
            content: 'Všeobecné obchodné podmienky pre organizácie, ktoré na GROWNi využívajú platené služby.'
        }
    ]
})
</script>
